import { render, staticRenderFns } from "./ColorDetector.vue?vue&type=template&id=0cc8a20e"
import script from "./ColorDetector.vue?vue&type=script&lang=ts"
export * from "./ColorDetector.vue?vue&type=script&lang=ts"
import style0 from "./ColorDetector.vue?vue&type=style&index=0&id=0cc8a20e&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports